import { ApiService } from "../..";

export const createRejectedSample = (data: { rejected_content: string; rejected_image_url: string[] }, sampleId:string) => {
  return ApiService.baseAction(
    `rejected-sample/${sampleId}/create`,
    {
      data,
    },
    "post"
  );
};
